export const BACKSPACE = 8;
export const ENTER = 13;
export const UP = 38;
export const DOWN = 40;

const keyIs = (e, ...keyCodes) => keyCodes.includes(e.which || e.keyCode);

export default keyIs;
